import { Dates } from "src/modules/utils/shared/dates";
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Type } from 'class-transformer';
import { SmBaseEntity } from 'src/modules/sm-base/shared/sm-base-entity.model';
import { Column, Entity, ManyToOne } from 'typeorm';
import { ClassRegisterSettings } from './class-register-settings.entity';
import { ClassRegister } from './class-register.entity';

@Entity()
export class SickNote extends SmBaseEntity {
    @ManyToOne(() => ClassRegister, (o: ClassRegister) => o.sickNotes, { onDelete: "CASCADE", nullable: false, orphanedRowAction: "delete"})
    classRegister: ClassRegister;

    @Column({default: 0})
    pupilId: number = 0;

    @Column()
    @Type(() => Date)
    fromDate: Date;

    @Column({default: -1})
    fromHour: number = -1;

    @Column()
    @Type(() => Date)
    toDate: Date;

    @Column({default: -1})
    toHour: number = -1;

    @Column({default: ""})
    reason: string = "";

    @Column({default: false})
    excused: boolean = false;

    @Column({nullable: true})
    @Type(() => Date)
    creationDate: Date;

    @Column({default: ""})
    createdBy: string = "";

    @Column({default: false})
    createdByParent: boolean = false;

    getMissDays(settings: ClassRegisterSettings): Date[] {
        let result: Date[] = [];
        let d = this.fromDate;
        while (d <= this.toDate) {
            if (Dates.eq(d, this.fromDate) && this.fromHour >= 1) {
                d = Dates.add(d, "day", 1);
                continue;
            }
            if (Dates.eq(d, this.toDate) && this.toHour >= 0) {
                d = Dates.add(d, "day", 1);
                continue;
            }
            if (settings.isSchoolDay(d)) {
                result.push(d);
            }
            d = Dates.add(d, "day", 1);
        }
        return result;
    }

    includes(date: Date, hour: number): boolean {
        let fromHour = Dates.eq(date, this.fromDate) ? this.fromHour : -1;
        let toHour = Dates.eq(date, this.toDate) ? this.toHour : -1;
        return Dates.geq(date, this.fromDate) && Dates.leq(date, this.toDate) && (fromHour == -1 || fromHour <= hour) && (toHour == -1 || toHour >= hour);
    }

    intersects(other: SickNote): boolean {
        return this.getCompareToDate().getTime() > other.getCompareFromDate().getTime() && this.getCompareFromDate().getTime() < other.getCompareToDate().getTime();
    }

    private getCompareFromDate(): Date {
        return Dates.add(new Date(this.fromDate), "hour", this.fromHour == -1 ? 0 : this.fromHour + 1);
    }

    private getCompareToDate(): Date {
        return Dates.add(Dates.add(new Date(this.toDate), "hour", this.fromHour == -1 ? 23 : this.fromHour + 1), "minute", 30);
    }
}